import { _ as _arrayPush } from "./auth-service-tools1226.js";
import { i as isArray_1 } from "./auth-service-tools1041.js";
var arrayPush = _arrayPush,
    isArray = isArray_1;

function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;
export { _baseGetAllKeys as _ };